export const wearDeviceFHIR = (client_id:string,patientId:string, extensions:any) => {
    return {
        "resourceType": "Device",
        "status": "active",
        "deviceName": [
            {
                "name": client_id,
                "type": "Wear Connect",
                "extension": [
                    {
                        "url": client_id,
                        "extension": extensions
                    }
                ]
            }
        ],
        "patient": {
            "reference": `Patient/${patientId}`
        }
    }
}

export const EHR = ["EPIC", "Cerner", "AthenaHealth", "Meditech","ECW"];
export const Wearable = ["Google Fit", "Dexcom", "Fitbit", "Oura", "Polar", "Omron", "Withings", "Strava", "Garmin", "iHealth"]
